__turbopack_context__.v({
  "grid": "QuestionsAndAnswers-module-scss-module__j1pRka__grid",
  "groupanswers": "QuestionsAndAnswers-module-scss-module__j1pRka__groupanswers",
});
